<template>
  <div class="slider-verify" :class="{ 'is-success': isSuccess }">
    <div class="slider-track">
      <div class="slider-fill" :style="{ width: sliderLeft + 'px' }"></div>
      <div class="slider-text" v-if="!isSuccess">
        <app-icon  class="app-icon" name="arrow_forward"></app-icon>
        <span>请向右滑动验证</span>
      </div>
      <div class="slider-text slider-text-success" v-else>
        <app-icon  class="app-icon" name="check_circle"></app-icon>
        <span>验证通过</span>
      </div>
    </div>
    <div class="slider-thumb" 
      :style="{ left: sliderLeft + 'px' }"
      @mousedown="startDrag"
      @touchstart.prevent="startDrag"
      :class="{ 'is-dragging': isDragging }">
      <app-icon  class="app-icon thumb-icon" :name="isSuccess ? 'check' : 'double_arrow'"></app-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderVerify',
  data() {
    return {
      isDragging: false,
      isSuccess: false,
      sliderLeft: 0,
      startX: 0,
      trackWidth: 0,
      thumbWidth: 44
    }
  },
  mounted() {
    this.trackWidth = this.$el.querySelector('.slider-track').offsetWidth
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.stopDrag)
    document.addEventListener('touchmove', this.onDrag)
    document.addEventListener('touchend', this.stopDrag)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    document.removeEventListener('touchmove', this.onDrag)
    document.removeEventListener('touchend', this.stopDrag)
  },
  methods: {
    startDrag(e) {
      if (this.isSuccess) return
      this.isDragging = true
      this.startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX
    },
    onDrag(e) {
      if (!this.isDragging) return
      const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX
      const diff = clientX - this.startX
      const maxLeft = this.trackWidth - this.thumbWidth
      this.sliderLeft = Math.max(0, Math.min(diff, maxLeft))
    },
    stopDrag() {
      if (!this.isDragging) return
      this.isDragging = false
      const maxLeft = this.trackWidth - this.thumbWidth
      const threshold = maxLeft * 0.9
      
      if (this.sliderLeft >= threshold) {
        this.sliderLeft = maxLeft
        this.isSuccess = true
        this.$emit('success')
      } else {
        this.sliderLeft = 0
        this.$emit('fail')
      }
    }
  }
}
</script>

<style scoped>
.slider-verify {
  --c-primary: #0052ff;
  --c-success: #10b981;
  --c-track: #eef2f7;
  --c-track-fill: rgba(0, 82, 255, 0.16);
  --c-thumb: #ffffff;
  --c-text: #64748b;
  position: relative;
  width: 100%;
  height: 44px;
  user-select: none;
}

.slider-track {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--c-track);
  border-radius: 8px;
  border: 1px solid #dbe4f0;
  overflow: hidden;
}

.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: var(--c-track-fill);
  border-radius: 8px;
  transition: none;
}

.is-dragging .slider-fill {
  transition: none;
}

.slider-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: var(--c-text);
  pointer-events: none;
}

.slider-text .app-icon {
  font-size: 18px;
}

.slider-text-success {
  color: var(--c-success);
}

.slider-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
  background: var(--c-thumb);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 3px 10px rgba(51, 65, 85, 0.16);
  transition: left 0.1s ease;
  z-index: 10;
}

.slider-thumb.is-dragging {
  cursor: grabbing;
  transition: none;
  transform: scale(1.05);
  box-shadow: 0 5px 14px rgba(51, 65, 85, 0.2);
}

.thumb-icon {
  font-size: 20px;
  color: var(--c-primary);
}

.is-success .slider-thumb {
  background: var(--c-success);
  cursor: default;
}

.is-success .thumb-icon {
  color: #ffffff;
}

.is-success .slider-track {
  border-color: var(--c-success);
}
</style>



// WEBPACK FOOTER //
// src/components/common/SliderVerify.vue